import { FC, HTMLAttributes } from 'react';

import './Text.css';

type TextVariant = 'h1' | 'h2' | 'h3' | 'h4' | 'p' | 'span' | 'label';
type TextSize = 'xs' | 'sm' | 'base' | 'lg' | 'xl' | '2xl';

interface TextProps extends HTMLAttributes<HTMLElement> {
  variant?: TextVariant;
  as?: TextVariant;
  size?: TextSize;
  bold?: boolean;
}

const variantElements = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  p: 'p',
  span: 'span',
  label: 'label'
} as const;

const sizeClasses = {
  xs: 'text--size-xs',
  sm: 'text--size-sm',
  md: 'text--size-md',
  lg: 'text--size-lg',
  xl: 'text--size-xl'
} as const;


const Text: FC<TextProps> = ({ 
  variant = 'p',
  as = variantElements[variant],
  size = 'md',
  className = '',
  children,
  ...props
}) => {
  const Component = variantElements[as];
  const variantClass = `text--${variant}`;
  const sizeClass = sizeClasses[size as keyof typeof sizeClasses];

  return (
    <Component 
      className={`text ${variantClass} ${sizeClass} ${className}`}
      {...props}
    >
      {children}
    </Component>
  );
};

export default Text; 